import { gql } from "@apollo/client";
import { useEffect, useState } from "react";
import PortalFooter from "../../../Reactportal/PortalFooter";
import Reactportal from "../../../Reactportal/Reactportal";
import ".././AddVendorAccount.scss";
import SelectedLanes from "./SelectedLanes";

export const GET_VEHICLE_CATEGORY_OF_USER = gql`
  query GetAllVehicleCategoryManagement($AccountID: ID) {
    getAllVehicleCategoryManagement(AccountID: $AccountID) {
      _id
      Unique_Id
      VehicleCategoryGroupData {
        _id
        VehicleType
        VehicleCategory {
          _id
          Unique_Id
          Name
          User_ID
          createdAt
          updatedAt
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_VEHICLE_TYPE = gql`
  query SearchVehicleTypeMasters($keyword: String) {
    searchVehicleTypeMasters(keyword: $keyword) {
      _id

      Search_Value
    }
  }
`;

export const GET_VEHICLE_CATEGORY = gql`
  query SearchVehicleCategory_With_VechileMasters($keyword: String!, $vehicleTypeId: ID) {
    searchVehicleCategory_With_VechileMasters(keyword: $keyword, Vehicle_Type_Id: $vehicleTypeId) {
      _id
      Unique_Id
      Name
      Search_Value
      Vehicle_Type
      User_ID
      createdAt
      updatedAt
    }
  }
`;
interface dataType {
  From_Location: string;
  From_Type: string;
  To_Location: string;
  To_Type: string;
  Is_Reverse: boolean;
}

const LanesPreview = ({ show, setShowModal, setFormatedData, FormatedData }) => {
  const [open, setOpen] = useState(show);
  const [formatedData, setformatedData] = useState<dataType[] | Array<undefined>>(FormatedData);
  useEffect(() => {
    setformatedData(FormatedData);
  }, [FormatedData]);

  const Closeformfunction2 = () => {
    setShowModal();

    setOpen(false);
  };

  return (
    <Reactportal
      open={open}
      onClose={Closeformfunction2}
      TypeOfPortal={"User Preference"}
      TypeOfId={"Load Id :"}
      UserRightsPortal=""
      id={""}
    >
      
      <div className="LanesContainer">

      <SelectedLanes formatedData={formatedData} setformatedData={setformatedData} />
      </div>
      <PortalFooter
        renderContent={() => <></>}
        disabled={false}
        submitform={""}
        submitType={""}
        SaveAndClose={() => {
          setFormatedData(formatedData);
          Closeformfunction2();
        }}
        handleformclose={() => {
          Closeformfunction2();
        }}
        Cancletype={"Cancel"}
        Delete={""}
        handleFileDelete={""}
        UserRightsPortal={""}
        TypeOfPortal={""}
        disableupload={""}
        name={""}
        loadingState={""}
      />
    </Reactportal>
  );
};

export default LanesPreview;
